import React, { useEffect, useState } from 'react'
import { getCommunity, updateCommunityGates } from '../services/onboardingService'
import { normalizeGates } from '../utils/gates'

export default function CommunityGateConfig({ communityId }) {
  const [gatesInput, setGatesInput] = useState('')
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')

  useEffect(() => {
    let active = true
    async function loadGates() {
      if (!communityId) {
        if (active) {
          setGatesInput('')
        }
        return
      }
      setLoading(true)
      setError('')
      try {
        const comm = await getCommunity({ communityId })
        if (!active) return
        const gates = normalizeGates(comm?.GATES || comm?.gates || comm?.GATE_LIST || comm?.gateList || '')
        setGatesInput(gates.join('\n'))
      } catch (err) {
        if (active) setError(err?.message || 'Failed to load gates')
      } finally {
        if (active) setLoading(false)
      }
    }

    loadGates()
    return () => {
      active = false
    }
  }, [communityId])

  async function handleSave(e) {
    e.preventDefault()
    if (!communityId) return
    setSaving(true)
    setError('')
    setMessage('')
    try {
      const idToken = sessionStorage.getItem('id_token') || ''
      await updateCommunityGates({ communityId, gates: normalizeGates(gatesInput) }, idToken)
      setMessage('Gate list updated')
    } catch (err) {
      setError(err?.message || 'Failed to update gates')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div>
          <h3 className="text-sm font-semibold text-gray-900">Entry / Exit Gates</h3>
          <p className="text-xs text-gray-500">Choose the gate names available to staff when logging entries.</p>
        </div>
      </div>
      <form onSubmit={handleSave} className="space-y-3">
        <textarea
          rows={4}
          value={gatesInput}
          onChange={(e) => setGatesInput(e.target.value)}
          placeholder="Main Gate\nGate 1\nService Gate"
          className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
        />
        <p className="text-[11px] text-gray-500">Enter one gate per line or separate with commas.</p>
        {error && <p className="text-sm text-red-600">{error}</p>}
        {message && <p className="text-sm text-green-600">{message}</p>}
        <button
          type="submit"
          disabled={saving || loading}
          className="px-3 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium disabled:opacity-50"
        >
          {saving ? 'Saving…' : 'Save Gates'}
        </button>
      </form>
    </div>
  )
}
